export default __webpack_public_path__ + "static/media/India_tag.2cf39c28.svg";